import "../../styles/components/nav/Footer.scss";

export default function Footer() {
    return <div className="footer">This is Footer Component</div>;
}
